// import {Container, Nav, Navbar, Button} from 'react-bootstrap';
import styles from '../Chat.module.css';
import {useState} from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
//import { Controller, Autoplay, Thumbs} from "swiper";
import SwiperCore, { Autoplay, Thumbs, Navigation} from 'swiper';
import 'swiper/swiper.min.css';



export const Media = ({lang}) => {

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  
  const slides_en = [
    {text: "<h1><b>Winner</b> of the Backer McKenzie Legal Tech Startup Challange</h1>", url: "/assets/hugolegacom/img/media/baker_l.webp", link:"https://www.legaltechstartupchallenge.com/"},
    {text: "<h1>Listed as one of <b>Europe’s leading pre-Series A startups</b></h1>", url: "/assets/hugolegacom/img/media/sifted_l.webp", link:"https://sifted.eu/pro/briefings"},
    {text: "<h1><b>Offical partner</b> with the Minstry of Justice of Estonia</h1>", url: "/assets/hugolegacom/img/media/justmin_l.webp", link:"https://www.foundme.io/uudised/2021/08/11/oigusidu-hugolegal-solmis-eesti-riigiga-35-miljoni-euro-suuruse-lepingu"},
    {text: " <h1><b>Winner</b> of the Legal Tech Chatbot competition</h1>", url: "/assets/hugolegacom/img/media/insider_l.webp", link:"https://businessinsider.com.pl/twoje-pieniadze/kredyt-we-franku-jak-sprawdzic-umowe-frankbot-chatbot-na-messengerze-dla-frankowiczow/cntb5cy"},
    {text: "<h1><b>The story of HUGO</b> and growing trend of Legal Tech</h1>", url: "/assets/hugolegacom/img/media/forbes_l.webp", link:"https://forbesbaltics.com/ee/tehnoloogia/artikkel/%C3%95igustehnoloogia-populaarsus-astub-fintechi-kandadel"},
    {text: "<h1><b>TOP 10</b> Legal Tech startups in Europe</h1>", url: "/assets/hugolegacom/img/media/eustartups_l.webp", link:"https://www.eu-startups.com/2022/04/10-european-legaltech-startups-shaking-up-the-industry-to-improve-our-daily-lives/"},
  ];
  const slides_et = [
    {text: "<h1>Baker Mckenzie korraldatud õigustehnoloogia konkursi võitja </h1>", url: "/assets/hugolegacom/img/media/baker_l.webp", link:"https://www.legaltechstartupchallenge.com/"},
    {text: "<h1>Nomineeritud kui Euroopa juhtiv pre-Series A õigusidu</h1>", url: "/assets/hugolegacom/img/media/sifted_l.webp", link:"https://sifted.eu/pro/briefings"},
    {text: "<h1>Justiitsministeeriumi ametlik koostööpartner </h1>", url: "/assets/hugolegacom/img/media/justmin_l.webp", link:"https://www.foundme.io/uudised/2021/08/11/oigusidu-hugolegal-solmis-eesti-riigiga-35-miljoni-euro-suuruse-lepingu"},
    {text: " <h1>Poola õigusroboti konkursi võitja</h1>", url: "/assets/hugolegacom/img/media/insider_l.webp", link:"https://businessinsider.com.pl/twoje-pieniadze/kredyt-we-franku-jak-sprawdzic-umowe-frankbot-chatbot-na-messengerze-dla-frankowiczow/cntb5cy"},
    {text: "<h1>Õigustehnoloogia populaarsus astub FinTechi kandadel</h1>", url: "/assets/hugolegacom/img/media/forbes_l.webp", link:"https://forbesbaltics.com/ee/tehnoloogia/artikkel/%C3%95igustehnoloogia-populaarsus-astub-fintechi-kandadel"},
    {text: "<h1>Valitud Euroopa 10 parima õigustehnoloogia idufirma hulka</h1>", url: "/assets/hugolegacom/img/media/eustartups_l.webp", link:"https://www.eu-startups.com/2022/04/10-european-legaltech-startups-shaking-up-the-industry-to-improve-our-daily-lives/"},
  ];
  const slides_ru = [
    {text: "<h1>Победитель конкурса юридических технологий, организованного Baker McKenzie</h1>", url: "/assets/hugolegacom/img/media/baker_l.webp", link:"https://www.legaltechstartupchallenge.com/"},
    {text: "<h1>Номинирован как ведущий европейский стартап в сфере права на стадии pre-Series A</h1>", url: "/assets/hugolegacom/img/media/sifted_l.webp", link:"https://sifted.eu/pro/briefings"},
    {text: "<h1>Официальный партнёр Министерства юстиции </h1>", url: "/assets/hugolegacom/img/media/justmin_l.webp", link:"https://www.foundme.io/uudised/2021/08/11/oigusidu-hugolegal-solmis-eesti-riigiga-35-miljoni-euro-suuruse-lepingu"},
    {text: " <h1>Победитель конкурса юридических роботов в Польше</h1>", url: "/assets/hugolegacom/img/media/insider_l.webp", link:"https://businessinsider.com.pl/twoje-pieniadze/kredyt-we-franku-jak-sprawdzic-umowe-frankbot-chatbot-na-messengerze-dla-frankowiczow/cntb5cy"},
    {text: "<h1>Популярность юридических технологий следует по пятам FinTech</h1>", url: "/assets/hugolegacom/img/media/forbes_l.webp", link:"https://forbesbaltics.com/ee/tehnoloogia/artikkel/%C3%95igustehnoloogia-populaarsus-astub-fintechi-kandadel"},
    {text: "<h1>Входит в десятку лучших европейских стартапов в сфере юридических технологий</h1>", url: "/assets/hugolegacom/img/media/eustartups_l.webp", link:"https://www.eu-startups.com/2022/04/10-european-legaltech-startups-shaking-up-the-industry-to-improve-our-daily-lives/"},
  ];

  SwiperCore.use([Navigation,Thumbs, Autoplay]);


  const readmore_en = "Read more";
  const readmore_et = "Loe edasi";
  const readmore_ru = "Читать далее";


  let params = {
    modules: [Autoplay, Thumbs, Navigation],
    loop: true,
    spaceBetween: 15,
    autoplay: {
      delay: 20000,
      disableOnInteraction: true
    },
    navigation: true,
    thumbs: {
      swiper: thumbsSwiper,
    },
  };
  let thumbsParams = {
    loop: true,
    onSwiper: setThumbsSwiper, 
    freeMode: true,
    slidesPerView:5,
    spaceBetween: 15,
    style: {
      width: "100%"
    }
  };
 



  return (
    <>
    <div className={styles['swiper-container']}>

      <Swiper
        className={`${styles['swiper']}`}
        {...params}
      >
        {lang === "et" ? (
              <>          
              {slides_et.map((item, index) => (
                <SwiperSlide key={`slide_${index}`}>
                  <div ><a href={item.link} target="_blank" rel="noreferrer">
                    <div className={`${styles['swiper-color-2']} col-12`} dangerouslySetInnerHTML={{__html: item.text}}></div>
                  
                  <div className={`${styles['link']} col-12`}>{readmore_et}</div>
                  </a>
                  </div>
                </SwiperSlide>         
              ))}
            </>

          ): lang === "en" ? (
            <>          
            {slides_en.map((item, index) => (

            <SwiperSlide key={`slide_${index}`}>
              <div ><a href={item.link} target="_blank" rel="noreferrer">
                <div className={`${styles['swiper-color-2']} col-12`} dangerouslySetInnerHTML={{__html: item.text}}></div>
              
              <div className={`${styles['link']} col-12`}>{readmore_en}</div>
              </a>
              </div>
            </SwiperSlide>  
                
          ))}
</>

        ):(
          <>          
          {slides_ru.map((item, index) => (

          <SwiperSlide key={`slide_${index}`}>
            <div ><a href={item.link} target="_blank" rel="noreferrer">
              <div className={`${styles['swiper-color-2']} col-12`} dangerouslySetInnerHTML={{__html: item.text}}></div>
            
            <div className={`${styles['link']} col-12`}>{readmore_ru}</div>
            </a>
            </div>
          </SwiperSlide>  
              
        ))}
</>

      )
        
        
        
        }
      </Swiper>



      <Swiper className={`${styles['swiper-thumb']}`}
      {...thumbsParams}
      >
          {slides_en.map((item, index) => (

          <SwiperSlide key={`slide_${index}`}>
              <img src={item.url} alt="" rel=""/>
          </SwiperSlide>  
              
          ))}

      </Swiper>
    </div>      
    </>
  );
};
